module.exports = __webpack_public_path__ + "img/logo-icon.f04de877.png";